import { createContext } from 'react';
import { Employee, BasicCompany, Company, UserRole } from 'src/types';

type AuthContext = {
  authUser: Employee;
  activeRole: UserRole;
  defaultUserCompany?: Company; // Use as default company for UI: date format, currency etc.
  firstUserCompany: Company; // Use as default company in dropdowns
  deviceKey: string;
  companiesWithEmployeePrefsEnabled: BasicCompany[];
};

export const AuthUserContext = createContext<AuthContext>({} as AuthContext);
